import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { totalLossAmountReceivable } from '@splitsecondconnect/ultramarine-shared';

import { MoreSectionsComponent } from 'app/shared/components/more-sections/more-sections.component';

import { BaseSectionComponent } from '../../../../../../shared/base-classes/sections/base-section.component';
import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { SingleDropdownComponent } from '../../../../../../shared/components/dropdowns/single-dropdown/single-dropdown.component';
import { DurationPickerComponent } from '../../../../../../shared/components/duration-picker/duration-picker.component';
import { InputFieldComponent } from '../../../../../../shared/components/input-field/input-field.component';
import {
	dateCast,
	numberCast,
	toDateString,
} from '../../../../../../shared/functions/sectionCasters.function';
import { VehicleInsurancesRecordModel } from '../../../models/vehicle-insurances-record.model';
import {
	VEHICLE_INSURANCE_CATEGORIES,
	VEHICLE_INSURANCE_COVERAGE_TYPES,
	VEHICLE_INSURANCE_PREMIUM_PERIODS,
} from '../../../translations/vehicle-insurances-select-items';

@Component({
	selector: 'app-vehicle-insurances-details',
	templateUrl: 'vehicle-insurances-details.component.html',
	imports: [
		ReactiveFormsModule,
		InputFieldComponent,
		SingleDropdownComponent,
		SectionWrapperComponent,
		DurationPickerComponent,
		MoreSectionsComponent,
	],
})
export class VehicleInsurancesDetailsComponent
	extends BaseSectionComponent<VehicleInsurancesRecordModel>
	implements OnInit
{
	protected _skipCount: number = 0;
	recordCategories = VEHICLE_INSURANCE_CATEGORIES;
	coverageTypes = VEHICLE_INSURANCE_COVERAGE_TYPES;
	premiumPeriods = VEHICLE_INSURANCE_PREMIUM_PERIODS;

	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			code: [null],

			externalReference: [null],
			startsAt: [null],
			endsAt: [null],
			recordCategory: [null],
			coverageType: [null],
			premiumPeriod: [null],
			excessAmount: [null],
			insuredValue: [null],
			totalLossPercentage: [null],
		});
	}

	public get totalLossAmount(): number {
		const insuredValue = Number(this.detailsForm.value.insuredValue);
		const totalLossPercentage = Number(
			this.detailsForm.value.totalLossPercentage,
		);
		if (
			isNaN(insuredValue) ||
			isNaN(totalLossPercentage) ||
			insuredValue == null ||
			totalLossPercentage == null
		) {
			return 0;
		}
		return totalLossAmountReceivable(insuredValue, totalLossPercentage);
	}
	protected _mapModelToForm(): void {
		const detailsFormData: any = {
			code: this.recordData().code,

			externalReference: this.recordData().externalReference,
			startsAt: toDateString(this.recordData().startsAt),
			endsAt: toDateString(this.recordData().endsAt),
			recordCategory: this.recordData().recordCategory,
			coverageType: this.recordData().coverageType,
			premiumPeriod: this.recordData().premiumPeriod,
			excessAmount: this.recordData().excessAmount,
			insuredValue: this.recordData().insuredValue,
			totalLossPercentage: this.recordData().totalLossPercentage,
		};
		this.detailsForm.setValue(detailsFormData, {
			emitEvent: false,
		});
	}

	protected _mapFormToModel(): Partial<VehicleInsurancesRecordModel> {
		return {
			code: this.detailsForm.value.code,

			externalReference: this.detailsForm.value.externalReference,
			startsAt: dateCast(this.detailsForm.value.startsAt),
			endsAt: dateCast(this.detailsForm.value.endsAt),
			recordCategory: this.detailsForm.value.recordCategory,
			coverageType: this.detailsForm.value.coverageType,
			premiumPeriod: this.detailsForm.value.premiumPeriod,
			excessAmount: numberCast(this.detailsForm.value.excessAmount),
			insuredValue: numberCast(this.detailsForm.value.insuredValue),
			totalLossPercentage: numberCast(
				this.detailsForm.value.totalLossPercentage,
			),
		};
	}
}
